export default __webpack_public_path__ + "static/media/nomineeNoteIcon.d70e3031.svg";